<template>
	<div :class="['results', singleLine ? 'single-line' : '', items==='loading' ? 'loading' : '']">
		<!-- <menu-bar></menu-bar> -->	

		<shelf v-if="!!items && items!=='loading'"></shelf>
		<div class="content">
			<bread-crumbs :theme="'dark'"></bread-crumbs>
			<div class="more-options">
				<a @click="changeBorderMode">
					<span class="font-small">Change mode</span> 
					<img :src="borderModeImgSrc" />
				</a>
			</div>

			<div class="results-options" v-if="totalResults>40000 && typeof items!= 'string'">
				<span class="item-size">Item size:
					<button :class="[itemsize==='big' ? 'active' : '']" @click="updateItemSize('big')">
						<span class="circles small"><i></i><i></i><i></i><i></i><i></i><i></i></span>
						<span>Small</span>
					</button>
					<button :class="[itemsize==='huge' ? 'active' : '']" @click="updateItemSize('huge')">
						<span class="circles big"><i></i><i></i><i></i><i></i></span>
						<span>Big</span>
					</button>
				</span>
				<span class="total-label">Total: 
					<span class="results-amount">
					{{totalResults}}
					results</span>
				</span>
			</div>
			<result-items :items="items"></result-items>
		</div>
	</div>
</template>
<!-- 
						<count-up :startVal="0"
						:endVal="totalResults"
						:decimals="0"
						:duration="3"
						:options="countOptions"></count-up>
 -->

<script>
import { store } from '@/store/index';
import CountUp from 'vue-countup-v2';
import { mapActions, mapGetters, mapState } from 'vuex';
import MenuBar from '../partials/MenuBar.vue';
import Shelf from '../partials/Shelf.vue';
import ResultItems from '../../components/ResultItems.vue';
import BreadCrumbs from '../../components/BreadCrumbs.vue';
import { countOptions } from '../../../utils';
export default {
	created()
	{
		if(!this.user){
			this.$router.push({ path: '/login', name: 'login'});
		}		
		store.dispatch('initSettings');
	},
	mounted()
	{
		if(!this.user){
			this.$router.push({ path: '/login', name: 'login'});
		}		
	},
	data() {
		return {
			countOptions
		}
	},
	watch: {
		'$route' (to, from) {
			if (!to.params.searchFilter) {
				this.searchFilterString('');
			}
			this.hideOverlay();
		}
	},
	beforeRouteUpdate (to, from, next) {
		// console.log("before route update.. ", to, from);
		if (to.name.indexOf('root')>-1) {
			// console.log("CLEAR SARCH FILTER");
			this.searchFilterString('');

		}
		next();
	},
	components: {
		MenuBar,
		'shelf': () => import('../partials/Shelf.vue'),
		BreadCrumbs,
		CountUp,
		ResultItems
	},
	methods:{
		...mapActions([
			'hideOverlay',
			'updateItemSize',
			'searchFilterString',
			'setBorderMode'
		]),
		changeBorderMode()
		{
			if(this.settings.borderMode=='circle')
			{
				this.setBorderMode('box15');
			}else{
				this.setBorderMode('circle');
			}
		},
		afterCount() {
			console.log("counter callback called");
		},
	},
	computed: {
		...mapState([
			'itemsFilterString',
			'itemsize','user','settings'
		]),
		...mapGetters({
			_storageItems:	'filteredItems',
			_activeRootCategory: 'activeRootCategory'
		}),
		items()
		{	
			try
			{		
			if(this._activeRootCategory.Id && 
				this._activeRootCategory.Id == 111100)
			{
				//Sort the items by desending Id if the category is new (111100)
				return _.sortBy(this._storageItems, 'id').reverse();
			}
			}catch{}

			//return default catergory items 
			return this._storageItems;
		},
		totalResults() {
			return this.items.length
		},
		borderModeImgSrc()
		{
			if(this.settings.borderMode=='circle')
			{
				return 'img/toggleToRect.svg';
			}else{
				return 'img/toggleToCircle.svg';
			}

		},
        singleLine() {
            return this.items.length < Math.max((window.innerWidth<1024 ? 4 : 5), 1)
        }
	}
}
</script>
<style lang="stylus" scoped>
@import '~rupture'
@import '~settings'
@lost gutter 30px

.content
	.more-options
		position relative
		top -22px
		+below(815px)
			position absolute
			top -5px
			width 30px
			height 30px
			left calc(100vw - 50px)
		a			
			cursor pointer
			position absolute
			top 0px
			right 55px
			display flex
			align-items center
			+below(815px)
				right 0px
			span
				color #999
				opacity 0.7
				+below(815px)
					display none
			&:hover
				span
					opacity 1
			img
				padding-left 5px
				width 35px
				height auto

.results
	min-width 768px
	//padding-top 49px
	// min-height calc(100% - 42px)
	min-height calc(100% - 78px)
	color #fff
	position relative
	backface-visibility hidden
	-webkit-overflow-scrolling touch
	&:not(.single-line)
		overflow hidden
	@media screen and (max-height:750px) and (orientation:landscape)
		min-height 660px
	.content
		//padding-top 225px
		position relative
		//transform translateY(0)

		background-color rgb(249, 249, 249)
		//background #061016 url('assets/main-bg.jpg') repeat-x 0 bottom
		background-color rgb(249, 249, 249)
		transition transform 0.3s ease-out
		+below(815px)
			padding-top 0px
	.active + .content
		//transform translateY(475px)
		//transition transform 0.3s 0.1s ease-out
		//+below(1400px)
			//transform translateY(420px)
	&.single-line, &.loading
		background-position 0 70%
		.content
			padding-top 148px
			min-height calc(100vh - 49px)
	.results-options
		position absolute 125px 2% false false
		.item-size
			display inline-block
			color rgba(#000, 0.4)
			border-right 1px solid rgba(#61829c, 0.3)
			margin-right 10px
			button
				display inline-block
				opacity 0.4
				color #000
				font-size 13px
				vertical-align bottom
				text-align left
				padding-right 14px
				&:first-child
					padding-left 10px
				&.active
					opacity 1
				span
					font-size 12px
					i
						background #000
						display inline-block
					&.small i
						width 6px
						height @width
						border-radius unit(@width/2, 'px')
						margin-right unit(@width/3, 'px')
					&.big i
						width 9px
						height @width
						border-radius unit(@width/2, 'px')
						margin-right unit(@width/3, 'px')
					& + span
						display block
						padding-top 6px



	.total-label
		font-size 13px
		color rgba(#000, 0.4) //rgba(#fff, 0.4)
		span
			color #000
	ul.breadcrumbs
		float left
		li
			display inline-block
			color #000

</style>
